var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 1.72159H11.4531L14.1094 4.33759V14.2784H4.29688V1.72159Z",
    stroke: "#222627",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9219 1.92044V4.68747H13.8594",
    stroke: "#222627",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.89062,
    y: 5.10794,
    width: 7,
    height: 7.625,
    rx: 1,
    fill: "#FF782C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79468 10.6222H5.95972L5.42578 9.73672C5.31592 9.55362 5.22583 9.4357 5.15552 9.38297C5.08521 9.33023 5.0105 9.30386 4.9314 9.30386H4.71167V10.6222H3.98657V7.21866H5.17969C5.98975 7.21866 6.39478 7.52628 6.39478 8.14151C6.39478 8.37296 6.32666 8.57144 6.19043 8.73697C6.05566 8.9025 5.86963 9.01895 5.63232 9.08633V9.09512C5.78906 9.14786 5.96265 9.32071 6.15308 9.61368L6.79468 10.6222ZM4.71167 7.77017V8.75015H5.06763C5.23755 8.75015 5.37378 8.70108 5.47632 8.60294C5.58032 8.50333 5.63232 8.37955 5.63232 8.2316C5.63232 7.92398 5.44849 7.77017 5.08081 7.77017H4.71167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.ce700d63d78c6ace2ee3543a44ab4b29.svg";
export { ForwardRef as ReactComponent };